import React, { useContext } from "react";
import { useConverters } from "./../../pm-converters/context";
import { RicosContext } from "./../../ricos-context";
import { useRootNodeContainerClasses } from "./class-name-strategies";
import classes from "./figure-scss";
const Figure = ({ NodeViewContent, ...props }) => {
  const { isMobile } = useContext(RicosContext);
  const converters = useConverters();
  const ricosNode = converters.fromPmNode(props.node.toJSON());
  const width = getContainerWidth(ricosNode.imageData, isMobile);
  const containerClasses = useRootNodeContainerClasses(ricosNode.imageData?.containerData);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      style: { width: width ? `min(100%, ${width}px)` : void 0 },
      className: containerClasses
    },
    /* @__PURE__ */ React.createElement(NodeViewContent, { as: "figure", className: classes.figure })
  );
};
const getContainerWidth = (imageData, isMobile) => {
  const disableCustomWidthMapper = imageData?.image?.width && isMobile && (Number(imageData?.containerData?.width?.custom) || 0) > 150;
  const disableCustomWidth = disableCustomWidthMapper ?? false;
  const customWidth = !disableCustomWidth ? imageData?.containerData?.width?.custom : void 0;
  const originalWidth = imageData?.containerData?.width?.size === "ORIGINAL" || disableCustomWidth ? imageData?.image?.width : void 0;
  const width = customWidth || originalWidth;
  return width;
};
export {
  Figure
};
//# sourceMappingURL=figure.js.map
